module.exports = __webpack_public_path__ + "static/media/ki.4043a2f8.webp";